import { useRef } from "react";

import { cn } from "@/lib/helpers/cn";
import type { CosignatureStatus } from "@/core/types";
import { useIsSticky } from "@/lib/hooks/useIsSticky";

import { BatchControls } from "../(batch)/BatchControls";
import type { CosignatureTab } from "../types";

import { StatusSelect } from "./components/StatusSelect";
import type { SupervisorAssignmentOptionValue } from "./types";
import { SupervisorAssignmentSelect } from "./components/SupervisorAssignmentSelect";

export type CosignatureFilterProps = {
  onStatusChange: (value: CosignatureStatus) => void;
  onSupervisorChange: (value: SupervisorAssignmentOptionValue | null) => void;
  status: Nullable<CosignatureStatus>;
  supervisor_id: SupervisorAssignmentOptionValue | null;
};

export function CosignatureFilters(props: CosignatureFilterProps & { tab: CosignatureTab }) {
  const { onStatusChange, onSupervisorChange, status, supervisor_id, tab } = props;
  const ref = useRef<HTMLDivElement>(null);
  const isSticky = useIsSticky(ref);

  return (
    <div
      className={cn(
        "tw:sticky tw:top-(--header-height) tw:z-10 tw:bg-fill-white",
        "tw:flex tw:justify-between tw:gap-4 tw:px-6 tw:max-md:flex-col tw:md:items-end",
        isSticky && "tw:shadow-sm",
      )}
      ref={ref}
    >
      <div className="tw:flex tw:items-end tw:gap-4">
        <SupervisorAssignmentSelect onChange={onSupervisorChange} value={supervisor_id} />
        <StatusSelect onChange={onStatusChange} tab={tab} value={status} />
      </div>

      <BatchControls />
    </div>
  );
}
